module.exports = __webpack_public_path__ + "static/multimedia-960a445d6bb17cf0ac434cbe528c38b1.png";